import { render, staticRenderFns } from "./ApproveTransferWarrantyStock.vue?vue&type=template&id=1194a540"
import script from "./ApproveTransferWarrantyStock.vue?vue&type=script&lang=js"
export * from "./ApproveTransferWarrantyStock.vue?vue&type=script&lang=js"
import style0 from "./ApproveTransferWarrantyStock.vue?vue&type=style&index=0&id=1194a540&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports